import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SignalsComponent } from "./components/scripts/signals.component";
import { SignalsInsightsComponent } from "./components/scripts/signalsInsights.component";
import { SignalsInsightsCreateEditComponent } from "./components/scripts/signalsInsightsCreateEdit.component";
import { SignalsScheduledComponent } from "./components/scripts/signalsScheduled.component";
import { SignalsScheduledCreateEditComponent } from "./components/scripts/signalsScheduledCreateEdit.component";
import { SignalsSyncComponent } from "./components/scripts/signalsSync.component";
import { SignalsTradePlansComponent } from "./components/scripts/signalsTradePlan.component";
import { SignalsUserQuestionComponent } from "./components/scripts/signalsUserQuestion.component";

const signalsRoutes: Routes = [
  {
    path: "tradingstudio",
    children: [
      { path: "", component: SignalsInsightsComponent },
      {
        path: "messages",
        children: [
          { path: "", component: SignalsInsightsComponent },
          { path: "create", component: SignalsInsightsCreateEditComponent },
          { path: "edit/:id", component: SignalsInsightsCreateEditComponent },
        ],
      },
      {
        path: "scheduled",
        children: [
          { path: "", component: SignalsScheduledComponent },
          { path: "create", component: SignalsScheduledCreateEditComponent },
          { path: "edit/:id", component: SignalsScheduledCreateEditComponent },
        ],
      },
      {
        path: "signals",
        children: [
          { path: "", component: SignalsComponent },
          { path: "sync", component: SignalsSyncComponent },
        ],
      },
      {
        path: "tradeplans",
        children: [{ path: "", component: SignalsTradePlansComponent }],
      },
      {
        path: "user-question",
        children: [
          { path: "", component: SignalsUserQuestionComponent },
          { path: "create", component: SignalsScheduledCreateEditComponent },
          { path: "edit/:id", component: SignalsScheduledCreateEditComponent },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(signalsRoutes)],
  exports: [RouterModule],
})
export class TradingStudioRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/tradingstudio-routing.module.ts